module.exports = __webpack_public_path__ + "img/sennheisergsp500.fdc99532.jpg";